import { useTranslation } from 'libs/i18n'
import type { PayoutStatus } from '../types/payouts.types'

export const useStatusOptions = (): { value: PayoutStatus; label: string }[] => {
	const { t } = useTranslation()

	return [
		{
			value: 'init',
			label: t('Initial')
		},
		{
			value: 'requested',
			label: t('Requested')
		},
		{
			value: 'processing',
			label: t('Processing')
		},
		{
			value: 'paid',
			label: t('Paid')
		},
		{
			value: 'cancelled',
			label: t('Cancelled')
		}
	]
}
